import { render, staticRenderFns } from "./DayPopup.vue?vue&type=template&id=2b6528c8&"
import script from "./DayPopup.vue?vue&type=script&lang=js&"
export * from "./DayPopup.vue?vue&type=script&lang=js&"
import style0 from "./DayPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports